export default __webpack_public_path__ + "static/doodle-underline-2-p-bd34f79060d6e992d1a175318cdbcdbf.svg";